// @ts-nocheck
import React from 'react';

const Switch = ({ checked, onChange, disabled, ariaLabel, className = '' }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => onChange && onChange(!checked)}
    className={`mov-switch ${className}`}
  >
    <span aria-hidden="true" className="mov-switch-thumb" />
  </button>
);

export default Switch;
